import { inquisitiveLogoSvg } from 'approot/activity-builder/introduction/activity-builder-intro';
import * as Styled from './activity-answers-print-header.style';

type Props = {
  unitName: string;
  contentName: string;
  userName: string;
};

const ActivityAnswersPrintHeader = ({
  unitName,
  contentName,
  userName,
}: Props) => {
  return (
    <Styled.ActivityAnswersPrintHeader>
      <Styled.ActivityAnswersPrintHeaderUser>
        {inquisitiveLogoSvg}
        <Styled.ActivityAnswerPrintHeaderUserName>
          {userName}
        </Styled.ActivityAnswerPrintHeaderUserName>
      </Styled.ActivityAnswersPrintHeaderUser>
      <Styled.ActivityAnswersPrintHeaderDetails>
        <Styled.ActivityAnswerPrintHeaderText>
          {unitName}
        </Styled.ActivityAnswerPrintHeaderText>
        <Styled.ActivityAnswerPrintHeaderText>
          <strong>{contentName}</strong>
        </Styled.ActivityAnswerPrintHeaderText>
      </Styled.ActivityAnswersPrintHeaderDetails>
    </Styled.ActivityAnswersPrintHeader>
  );
};

export default ActivityAnswersPrintHeader;
